import { combineReducers } from 'redux'
import { combineActions, handleActions } from 'redux-actions'

import * as searchAction from '../../search/store/actions'

import { getCompanyDetail, getCompanyDetailSuccess, getCompanyDetailFailure } from './actions'
import { defaultInfo, defaultLoading, defaultError } from './defaultState'

export const info = handleActions({
  [getCompanyDetail]: () => (defaultInfo),
  [getCompanyDetailSuccess]: (state, { payload: { info } }) => ({ ...info })
}, defaultInfo)

export const loading = handleActions({
  [getCompanyDetail]: (state, { payload: { id } }) => id,
  [combineActions(getCompanyDetailSuccess, getCompanyDetailFailure)]: () => defaultLoading
}, defaultLoading)

export const error = handleActions({
  // need to clear error also on job selection, as it might contain company profile
  [combineActions(getCompanyDetail, searchAction.company.setSelectedId, searchAction.job.setSelectedId)]: () => defaultError,
  [getCompanyDetailFailure]: (state, { meta: { id } }) => id
}, defaultError)

export default combineReducers({
  info, loading, error
})
